import React from 'react';

import { ProductSize } from '../../../api-client';
import { formatCurrency } from '../../../utils/data-format-enchanters/currency-enchanter';

import './bv-product-price.scss';

interface IBVProductPrice {
    className?: string;
    sizes?: ProductSize[];
    isMultisize?: boolean;
}

const BVProductPrice: React.FunctionComponent<IBVProductPrice> = ({ className, sizes, isMultisize }) => (
    sizes && sizes.length > 0
        ?
        <div className={`bv-product-price-container ${className}`}>
            {sizes[0].priceGross && sizes[0].priceGross.amount !== -1 &&
                <div className="product-price-wrapper price-sug">
                    <span className="price">
                        {formatCurrency(sizes[0].priceGross.amount, sizes[0].priceGross.currency)}
                    </span>
                </div>
            }
            {sizes[0].priceNet && sizes[0].priceNet.amount !== -1 &&
                <div className="product-price-wrapper price-net">
                    <span className="price">
                        {formatCurrency(sizes[0].priceNet.amount, sizes[0].priceNet.currency)}
                    </span>
                </div>
            }
        </div>
        :
        <div className={`bv-product-price-container ${className}`}>
            <div className="product-price-wrapper">
                <span className="price"> - </span>
            </div>
        </div>
);

export default BVProductPrice;